export default {
      id: "icon-preservatif-usage",
      viewBox: "0 0 118.7 164",
      url: __webpack_public_path__ + "icons.svg#icon-preservatif",
      toString: function () {
        return this.url;
      }
    }